import { defineElement, html, TemplateElement } from '@webtides/element-js';
import { formatDate, getCurrentLocale, getRelativeTimeFormat } from '../../utils/dates';

/**
 * @property { string } date
 * @property { string } locale
 */
export default class RelativeDate extends TemplateElement {
    properties() {
        return {
            date: '',
            locale: '',
        };
    }

    isOlderThanAWeek(date) {
        const currentDate = new Date();
        const oneWeekMs = 604800000;
        return currentDate - date > oneWeekMs;
    }

    template() {
        const inputDate = new Date(this.date);
        if (Number.isNaN(inputDate.getTime())) return html`<time></time>`;
        const locale = this.locale || getCurrentLocale();

        const relativeDate = this.isOlderThanAWeek(inputDate)
            ? formatDate(inputDate, 'dd.MM.yyyy')
            : getRelativeTimeFormat(inputDate, locale);

        return html`<time>${relativeDate}</time>`;
    }
}

defineElement('mb-relative-date', RelativeDate);
